<template>
  <div class="warp">
    <el-col
      :span="6"
      v-for="(item, index) in patientList"
      :key="index"
      style="margin: 0 10px 5px 0"
    >
      <el-card class="box-card">
        <div class="card_warp">
          <div class="card_warp-top">
            <div class="card_warp-top-title">
              <div>
                <el-avatar
                  src="https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png"
                ></el-avatar>
              </div>
              <div class="card_warp-top-name">
                {{ item.patientName }}
              </div>
              <div class="card_warp-top-age">
                {{
                  item.patientGender == 10901
                    ? "男"
                    : item.patientGender == 10902
                    ? "女"
                    : ""
                }}
                {{ item.patientAge }}岁
              </div>
            </div>
            <div class="card_warp-status">
              {{ ORDER_STATUS[item.status] }}
            </div>
          </div>
          <div class="card_warp-content">
            <div>
              咨询类型：
              {{ ORDER_TYPE[item.goodsId]["name"] }}
              {{
                item.treatmentType
                  ? item.treatmentType === 2
                    ? "(复诊开药)"
                    : "(在线咨询)"
                  : ""
              }}
            </div>
            <div
              style="margin: 15px 0"
              v-if="['1', '5'].indexOf(item.goodsId) === -1"
            >
              预约时间：{{ item.scheduleDate }}
              {{
                item.schedulePeriodStart
                  ? " ( " +
                    item.schedulePeriodStart +
                    " - " +
                    item.schedulePeriodEnd +
                    " )"
                  : ""
              }}
            </div>
            <div style="margin: 15px 0" v-else>
              创建时间：{{ item.gmtCreate }}
            </div>
            <div>手机号码：{{ item.patientMobile }}</div>
          </div>
        </div>
        <div class="btn_flex">
          <div>
            <el-button type="text" @click="headldetail(item)">{{
              item.status === 10002 ? "接诊" : "查看问诊"
            }}</el-button>
          </div>
          <div>
            <el-button type="text" @click="patientsHandle(item)"
              >查看患者信息</el-button
            >
          </div>
        </div>
      </el-card>
    </el-col>
  </div>
</template>
<script>
import { ORDER_STATUS, ORDER_TYPE } from "@/utils/constants";
import { reception } from "@/api";

export default {
  name: "userinfo",
  props: {
    patientList: Array,
  },
  data() {
    return {
      ORDER_STATUS,
      ORDER_TYPE,
    };
  },
  methods: {
    // 接诊
    headldetail(item) {
      if(item.status === 10002)this.reception(item);
      if (item.channelCode != "budan") {
        if (!item.accid) {
          this.$message({
            showClose: true,
            message: "该会员信息已被删除,无法进行问诊",
            type: "error",
          });
          return;
        }
        let query = {
          sessionId: "p2p-" + item.accid,
          treatId: item.orderNo,
          patientId: item.patientId,
          status: item.status,
          doctorMobile: item.doctorMobile,
          patientName: item.patientName,
          memberId: item.memberId,
        };
        this.$router.push({
          path: "/index/work/chart",
          query,
        });
      } else {
        if (item.showType) {
          this.userDialogVisible.value = true;
        } else {
          const query = {
            sessionId: "p2p-" + 1111111,
            treatId: item.orderNo,
            patientId: item.patientId,
            status: 10002,
            type: "replenishment",
          };
          this.$router.push({
            path: "/index/work/chart",
            query,
          });
        }
      }
    },
    // 接诊开始接口
    async reception(item) {
      await reception({id: item.orderNo});
    },
    //查看病历
    patientsHandle(item) {
      if (item.patientId == null || item.patientId == "") {
        this.$message({
          showClose: true,
          message: "该病历信息不存在或者已被删除",
          type: "error",
        });
        return;
      }
      let query = {
        prescriptionId: item.patientId,
        orderNo: item.orderNo,
        treatmentType: item.treatmentType
      };
      this.$router.push({
        path: "/index/work/patientDetails",
        query,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.warp {
  display: flex;
  flex-wrap: wrap;

  .card_warp {
    .card_warp-top {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-family: SourceHanSansCN-Bold, SourceHanSansCN;
      .card_warp-top-title {
        display: flex;
        align-items: center;
        .card_warp-top-name {
          font-size: 20px;
          font-weight: bold;
          color: #333333;
          margin: 0 20px;
        }
        .card_warp-top-age {
          font-size: 16px;
          font-weight: 400;
          color: #333333;
        }
      }
      .card_warp-status {
        width: 58px;
        height: 24px;
        font-size: 14px;
        line-height: 24px;
        text-align: center;
        color: #fff;
        border-radius: 20px;
        background: #e94709;
      }
    }
    .card_warp-content {
      margin: 20px 0;
      font-family: SourceHanSansCN-Regular, SourceHanSansCN;
      font-size: 16px;
      font-weight: 400;
      color: #666666;
    }
  }

  .btn_flex {
    font-size: 16px;
    font-family: SourceHanSansCN-Regular, SourceHanSansCN;
    font-weight: 400;
    display: flex;
    border-top: 1px solid #f0f0f0;
    div {
      width: 50%;
      text-align: center;
    }
    div:first-child {
      border-right: 1px solid #f0f0f0;
    }
    button {
      font-weight: bold;
    }
  }
}
</style>